import type { Cart } from "@packages/sdk";

import type { Payment } from "../types/payment.types";
import { getDateSanitized } from "./getDateSanitized";

type GetTrialTypeProps = { cart?: Cart };

export const getTrialType = ({
  cart,
}: GetTrialTypeProps): Payment["trialType"] => {
  if (cart) {
    if (cart.intro_offer) return "paid";

    if (
      cart.trial_end_date &&
      getDateSanitized({ date: new Date(cart.trial_end_date) }) >
        getDateSanitized({ date: new Date() })
    )
      return "free";
  }

  return null;
};
